import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../utils/globals';

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    padding: '24px 16px',
  },
  card: {
    background: '#fff',
    borderRadius: 18,
    padding: '40px 36px',
    width: '100%',
    maxWidth: 420,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  iconWrap: {
    width: 56, height: 56, borderRadius: '50%',
    background: 'linear-gradient(135deg, #eb3349, #f45c43)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 24, marginBottom: 20,
  },
  title: { fontSize: 22, fontWeight: 700, color: '#1a1a2e', margin: '0 0 6px' },
  sub: { fontSize: 13, color: '#64748b', margin: '0 0 28px' },
  label: { fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block' },
  input: {
    width: '100%', padding: '11px 14px',
    border: '1px solid #e2e8f0', borderRadius: 8,
    fontSize: 14, outline: 'none', color: '#1a1a2e',
    background: '#f8fafc', boxSizing: 'border-box',
    marginBottom: 16,
  },
  btn: {
    width: '100%', padding: '12px',
    background: 'linear-gradient(135deg, #eb3349 0%, #f45c43 100%)',
    color: '#fff', border: 'none', borderRadius: 8,
    fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 4,
  },
  error: { color: '#eb3349', fontSize: 13, marginTop: 12, textAlign: 'center' },
  success: { color: '#11998e', fontSize: 13, marginTop: 12, textAlign: 'center' },
  backLink: { display: 'block', textAlign: 'center', marginTop: 20, fontSize: 13, color: '#64748b', textDecoration: 'none' },
};

function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get('token');
    if (tokenParam) setToken(tokenParam);
  }, [location]);

  const postUpdatePassword = async (payload) => {
    const candidates = ['/auth/update-password', '/update-password'];
    let lastError;

    for (const path of candidates) {
      try {
        return await axios.post(`${BASE_URL}${path}`, payload);
      } catch (err) {
        lastError = err;
        if (err?.response?.status !== 404) {
          throw err;
        }
      }
    }

    throw lastError;
  };

  const handleReset = async () => {
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      await postUpdatePassword({
        token,
        newPassword,
        confirmPassword,
      });
      setSuccess('Password reset successfully. Redirecting to login...');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Error resetting password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.iconWrap}>🔑</div>
        <h2 style={s.title}>Set New Password</h2>
        <p style={s.sub}>Enter your new password below to complete the reset</p>

        <label style={s.label}>New Password</label>
        <input
          style={s.input}
          type='password'
          placeholder='Enter new password'
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <label style={s.label}>Confirm New Password</label>
        <input
          style={s.input}
          type='password'
          placeholder='Confirm new password'
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <button style={s.btn} onClick={handleReset} disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </button>

        {error && <p style={s.error}>{error}</p>}
        {success && <p style={s.success}>{success}</p>}

        <Link to='/' style={s.backLink}>← Back to Login</Link>
      </div>
    </div>
  );
}

export default ResetPassword;
